import { Input, Space } from "antd"
import { Material } from "./materialsModel"
import BudgetInputNumber from "./BudgetInputNumber"
import AddRemove from './AddRemove'
import BudgetStatistic from './BudgetStatistic'
import BudgetTable from './BudgetTable'
import { useContext } from "react"
import BudgetCalculatorContext from "./BudgetCalculatorContext"

const Materials = () => {
  const { worksheet: { data: { materials } }, summary, dispatch } = useContext(BudgetCalculatorContext)

  const columns = [
    {
      title: 'Expense',
      dataIndex: 'description',
      key: 'description',
      render: (value: string, _: Material, index: number) => {
        return <Input value={value} onChange={e => dispatch({ type: 'MATERIAL_DESCRIPTION_CHANGED', index, payload: e.target.value })} />
      }
    },
    {
      title: 'Monthly Cost',
      key: 'monthlyCost',
      render: (_: number, record: Material, index: number) => {
        return <BudgetInputNumber
          value={Math.round((record.annualCost ?? 0) / 12)}
          money
          onChange={(e) => dispatch({ type: 'MATERIAL_ANNUAL_COST_CHANGED', index, payload: e * 12 })} />
      }
    },
    {
      title: 'Annual Cost',
      dataIndex: 'annualCost',
      key: 'annualCost',
      render: (value: number, _: Material, index: number) => {
        return <BudgetInputNumber
          value={value}
          money
          onChange={(e) => dispatch({ type: 'MATERIAL_ANNUAL_COST_CHANGED', index, payload: e })} />
      }
    },
    {
      key: 'operations',
      render: (_: number, _record: Material, index: number) => {
        return <AddRemove
          onAdd={() => dispatch({ type: 'ADD_MATERIAL', index })}
          onRemove={() => dispatch({ type: 'REMOVE_MATERIAL', index })} />
      }
    }
  ]

  return <Space direction="vertical" size="large">
    <BudgetStatistic title="Total Annual Cost" value={summary.materials} statisticStyle="dollars" />
    <BudgetTable
      columns={columns}
      dataSource={materials}
    />
  </Space>
}
export default Materials
